import { makeActionCreator } from '../../../utilities'
import { IntubationConstants } from './intubation.constants'

export const setDate = makeActionCreator(IntubationConstants.SET_DATE, 'date')
export const setTime = makeActionCreator(IntubationConstants.SET_TIME, 'time')
export const setDateTime = makeActionCreator(IntubationConstants.SET_DATE_TIME, 'dateTime')
export const setAssessedBy = makeActionCreator(IntubationConstants.SET_ASSESSED_BY, 'assessedBy')
export const setRolePerforming = makeActionCreator(IntubationConstants.SET_ROLE_PERFORMING, 'rolePerforming')
export const setSuccessfulAttempt = makeActionCreator(IntubationConstants.SET_SUCCESSFUL_ATTEMPT, 'successfulAttempt')
export const setAttempts = makeActionCreator(IntubationConstants.SET_ATTEMPTS, 'attempts')
export const setSize = makeActionCreator(IntubationConstants.SET_SIZE, 'size')
export const setDistance = makeActionCreator(IntubationConstants.SET_DISTANCE, 'distance')
export const setDistanceUnit = makeActionCreator(IntubationConstants.SET_DISTANCE_UNIT, 'distanceUnit')
export const setMethod = makeActionCreator(IntubationConstants.SET_METHOD, 'method')
export const setSecuredVia = makeActionCreator(IntubationConstants.SET_SECURED_VIA, 'securedVia')
export const setVerifiedBy = makeActionCreator(IntubationConstants.SET_VERIFIED_BY, 'verifiedBy')
export const setVerificationVia = makeActionCreator(IntubationConstants.SET_VERIFICATION_VIA, 'verificationVia')
export const setAirwayPlacementTechnique = makeActionCreator(
  IntubationConstants.SET_AIRWAY_PLACEMENT_TECHNIQUE,
  'airwayPlacementTechnique'
)
export const setAirwayPlacementTechniquePNNV = makeActionCreator(
  IntubationConstants.SET_AIRWAY_PLACEMENT_TECHNIQUE_PNNV,
  'airwayPlacementTechniquePNNV'
)
export const setRSIProtocol = makeActionCreator(IntubationConstants.SET_RSI_PROTOCOL, 'rSIProtocol')
export const setMallampati = makeActionCreator(IntubationConstants.SET_MALLAMPATI, 'mallampati')
export const setSellickManeuver = makeActionCreator(IntubationConstants.SET_SELLICK_MANEUVER, 'sellickManeuver')
export const setLaryngoscopicGrade = makeActionCreator(
  IntubationConstants.SET_LARYNGOSCOPIC_GRADE,
  'laryngoscopicGrade'
)
export const setStyletUsed = makeActionCreator(IntubationConstants.SET_STYLET_USED, 'styletUsed')
export const setCuffFill = makeActionCreator(IntubationConstants.SET_CUFF_FILL, 'cuffFill')
export const setCuffFillQty = makeActionCreator(IntubationConstants.SET_CUFF_FILL_QTY, 'cuffFillQty')
export const setLaryngoscopeBlade = makeActionCreator(IntubationConstants.SET_LARYNGOSCOPE_BLADE, 'laryngoscopeBlade')
export const setIndications = makeActionCreator(IntubationConstants.SET_INDICATIONS, 'indications')
export const setDecisiontoManageTime = makeActionCreator(IntubationConstants.SET_DECISION_TO_MANAGE_TIME, 'time')
export const setDecisiontoManageDate = makeActionCreator(IntubationConstants.SET_DECISION_TO_MANAGE_DATE, 'date')
export const setDecisiontoManageDateTime = makeActionCreator(
  IntubationConstants.SET_DECISION_TO_MANAGE_DATE_TIME,
  'decisiontoManageDateTime'
)
export const setAbandonedTime = makeActionCreator(IntubationConstants.SET_ABANDONED_TIME, 'time')
export const setAbandonedDate = makeActionCreator(IntubationConstants.SET_ABANDONED_DATE, 'date')
export const setAbandonedDateTime = makeActionCreator(IntubationConstants.SET_ABANDONED_DATE_TIME, 'abandonedDateTime')
export const setAirwayComplications = makeActionCreator(
  IntubationConstants.SET_AIRWAY_COMPLICATIONS,
  'airwayComplications'
)
export const setAirwayComplicationsPNNV = makeActionCreator(
  IntubationConstants.SET_AIRWAY_COMPLICATIONS_PNNV,
  'airwayComplicationsPNNV'
)
export const setProcedureComplications = makeActionCreator(
  IntubationConstants.SET_PROCEDURE_COMPLICATIONS,
  'procedureComplications'
)
export const setResponse = makeActionCreator(IntubationConstants.SET_RESPONSE, 'response')
export const setAuthorization = makeActionCreator(IntubationConstants.SET_AUTHORIZATION, 'authorization')
export const setComments = makeActionCreator(IntubationConstants.SET_COMMENTS, 'comments')
export const setAddToTimeLine = makeActionCreator(IntubationConstants.SET_ADD_TO_TIMELINE, 'addToTimeline')
export const onSelectIntubationProcedure = makeActionCreator(IntubationConstants.ON_SELECT_INTUBATION)
export const saveIntubation = makeActionCreator(IntubationConstants.SAVE_INTUBATION)
export const setState = makeActionCreator(IntubationConstants.SET_STATE, 'intubationState')
export const resetState = makeActionCreator(IntubationConstants.RESET_STATE)
export const setUpdateInputRows = makeActionCreator(IntubationConstants.SET_UPDATE_INPUT_ROWS, 'updateInputRows')
export const setIntubationDefatults = makeActionCreator(
  IntubationConstants.SET_INTUBATION_DEFAULTS,
  'intubationDefaults'
)
export const setReasonsForFailure = makeActionCreator(IntubationConstants.SET_REASONS_FOR_FAILURE, 'reasonsForFailure')
export const setProcedurePerformedByAnotherUnit = makeActionCreator(
  IntubationConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT,
  'procedurePerformedByAnotherUnit'
)
export const setProcedurePerformedByAnotherUnitPNNV = makeActionCreator(
  IntubationConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV,
  'procedurePerformedByAnotherUnitPNNV'
)
